/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';

/**
 * 
 * @export
 * @interface ProductProfitabilitySummaryData
 */
export interface ProductProfitabilitySummaryData {
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    profitableProducts?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    lossProducts?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    productsWithoutPurchasePrice?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    purchaseCostUnknownCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    purchaseCostEstimatedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilitySummaryData
     */
    purchaseCostComplete?: boolean;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    unallocatedAdjustmentsNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    unallocatedAdjustmentsGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    unallocatedAdjustmentUnknownOrderCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilitySummaryData
     */
    unallocatedAdjustmentComplete?: boolean;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    purchasePrice?: MoneyOutput;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    grossMargin?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    allocatedMarketingSpend?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    profitAfterMarketing?: NullableMoneyOutput | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductProfitabilitySummaryData
     */
    marketingAllocationComplete?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    unresolvedPurchaseCostOrderCount?: number;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ProductProfitabilitySummaryData
     */
    excludedNonProductAmount?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    excludedNonProductOrderCount?: number;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ProductProfitabilitySummaryData
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    actionableUnknownLineCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilitySummaryData
     */
    productsWithActionableUnknownPurchaseCost?: number;
}

/**
 * Check if a given object implements the ProductProfitabilitySummaryData interface.
 */
export function instanceOfProductProfitabilitySummaryData(value: object): value is ProductProfitabilitySummaryData {
    return true;
}

export function ProductProfitabilitySummaryDataFromJSON(json: any): ProductProfitabilitySummaryData {
    return ProductProfitabilitySummaryDataFromJSONTyped(json, false);
}

export function ProductProfitabilitySummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilitySummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'profitableProducts': json['profitableProducts'] == null ? undefined : json['profitableProducts'],
        'lossProducts': json['lossProducts'] == null ? undefined : json['lossProducts'],
        'productsWithoutPurchasePrice': json['productsWithoutPurchasePrice'] == null ? undefined : json['productsWithoutPurchasePrice'],
        'purchaseCostUnknownCount': json['purchaseCostUnknownCount'] == null ? undefined : json['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': json['purchaseCostEstimatedCount'] == null ? undefined : json['purchaseCostEstimatedCount'],
        'purchaseCostComplete': json['purchaseCostComplete'] == null ? undefined : json['purchaseCostComplete'],
        'unallocatedAdjustmentsNet': json['unallocatedAdjustmentsNet'] === undefined ? undefined : json['unallocatedAdjustmentsNet'] === null ? null : NullableMoneyOutputFromJSON(json['unallocatedAdjustmentsNet']),
        'unallocatedAdjustmentsGross': json['unallocatedAdjustmentsGross'] === undefined ? undefined : json['unallocatedAdjustmentsGross'] === null ? null : NullableMoneyOutputFromJSON(json['unallocatedAdjustmentsGross']),
        'unallocatedAdjustmentUnknownOrderCount': json['unallocatedAdjustmentUnknownOrderCount'] == null ? undefined : json['unallocatedAdjustmentUnknownOrderCount'],
        'unallocatedAdjustmentComplete': json['unallocatedAdjustmentComplete'] == null ? undefined : json['unallocatedAdjustmentComplete'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'purchasePrice': json['purchasePrice'] == null ? undefined : MoneyOutputFromJSON(json['purchasePrice']),
        'grossMargin': json['grossMargin'] === undefined ? undefined : json['grossMargin'] === null ? null : NullableMoneyOutputFromJSON(json['grossMargin']),
        'allocatedMarketingSpend': json['allocatedMarketingSpend'] === undefined ? undefined : json['allocatedMarketingSpend'] === null ? null : NullableMoneyOutputFromJSON(json['allocatedMarketingSpend']),
        'profitAfterMarketing': json['profitAfterMarketing'] === undefined ? undefined : json['profitAfterMarketing'] === null ? null : NullableMoneyOutputFromJSON(json['profitAfterMarketing']),
        'marketingAllocationComplete': json['marketingAllocationComplete'] == null ? undefined : json['marketingAllocationComplete'],
        'unresolvedPurchaseCostOrderCount': json['unresolvedPurchaseCostOrderCount'] == null ? undefined : json['unresolvedPurchaseCostOrderCount'],
        'excludedNonProductAmount': json['excludedNonProductAmount'] === undefined ? undefined : json['excludedNonProductAmount'] === null ? null : NullableMoneyOutputFromJSON(json['excludedNonProductAmount']),
        'excludedNonProductOrderCount': json['excludedNonProductOrderCount'] == null ? undefined : json['excludedNonProductOrderCount'],
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'actionableUnknownLineCount': json['actionableUnknownLineCount'] == null ? undefined : json['actionableUnknownLineCount'],
        'productsWithActionableUnknownPurchaseCost': json['productsWithActionableUnknownPurchaseCost'] == null ? undefined : json['productsWithActionableUnknownPurchaseCost'],
    };
}

export function ProductProfitabilitySummaryDataToJSON(json: any): ProductProfitabilitySummaryData {
    return ProductProfitabilitySummaryDataToJSONTyped(json, false);
}

export function ProductProfitabilitySummaryDataToJSONTyped(value?: ProductProfitabilitySummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'profitableProducts': value['profitableProducts'],
        'lossProducts': value['lossProducts'],
        'productsWithoutPurchasePrice': value['productsWithoutPurchasePrice'],
        'purchaseCostUnknownCount': value['purchaseCostUnknownCount'],
        'purchaseCostEstimatedCount': value['purchaseCostEstimatedCount'],
        'purchaseCostComplete': value['purchaseCostComplete'],
        'unallocatedAdjustmentsNet': NullableMoneyOutputToJSON(value['unallocatedAdjustmentsNet']),
        'unallocatedAdjustmentsGross': NullableMoneyOutputToJSON(value['unallocatedAdjustmentsGross']),
        'unallocatedAdjustmentUnknownOrderCount': value['unallocatedAdjustmentUnknownOrderCount'],
        'unallocatedAdjustmentComplete': value['unallocatedAdjustmentComplete'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'purchasePrice': MoneyOutputToJSON(value['purchasePrice']),
        'grossMargin': NullableMoneyOutputToJSON(value['grossMargin']),
        'allocatedMarketingSpend': NullableMoneyOutputToJSON(value['allocatedMarketingSpend']),
        'profitAfterMarketing': NullableMoneyOutputToJSON(value['profitAfterMarketing']),
        'marketingAllocationComplete': value['marketingAllocationComplete'],
        'unresolvedPurchaseCostOrderCount': value['unresolvedPurchaseCostOrderCount'],
        'excludedNonProductAmount': NullableMoneyOutputToJSON(value['excludedNonProductAmount']),
        'excludedNonProductOrderCount': value['excludedNonProductOrderCount'],
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'actionableUnknownLineCount': value['actionableUnknownLineCount'],
        'productsWithActionableUnknownPurchaseCost': value['productsWithActionableUnknownPurchaseCost'],
    };
}

